import React from 'react';
import PropTypes from 'prop-types';
import { DayInfo } from '../shared-component/day-info';

export const BookingInfoComp = ({ booking, selectedDate }) => {
  const { details = {} } = booking || {};
  const {
    booking_id: bookingId,
    payout,
    guest,
    expires_in: expiresIn,
    listing,
    obj_state: objState,
    obj_state_metadata: objStateMetaData,
    schedule,
    timezone,
    calculations
  } = details;
  const infoProps = { bookingId, payout, guest, expiresIn, listing, objState, schedule, timezone, objStateMetaData, calculations };
  return (
    <div key={`booking-${bookingId}`}>
      <DayInfo
        key={`day-info-${bookingId}`}
        selectedDate={selectedDate}
        {...infoProps}
      />
      <hr />
    </div>
  );
};

BookingInfoComp.propTypes = {
  booking: PropTypes.object,
  selectedDate: PropTypes.instanceOf(Date)
};
